export default "__VITE_ASSET__OFK9KWa7__"